import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { RequestService } from '../request.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  api = {
    root: '/dashboard',
    url: '/url',
  };

  constructor(private client: RequestService) {}

  get url() {
    return this.client
      .get<any>({
        uri: this.api.root + this.api.url,
      })
      .pipe(map(response => response.url));
  }
}
